export default __webpack_public_path__ + "static/media/gallery_05.26f8b829.jpg";